import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { messageCreer } from "../actions/messageActions";
import { listeClients } from "../actions/clientsActions";
import axios from "axios";
import { Select, message } from "antd";
import "../MessageCree.css";
import messageimg from "../assets/message.png";
import "antd/dist/reset.css";

const { Option } = Select;

const MessageCree = () => {
  const [obj_msg, setObjMsg] = useState("");
  const [text_msg, setTextMsg] = useState("");
  const [edit, setEdit] = useState(false);
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [categoryOptions] = useState([
    { id: "1", value: "Promotion" },
    { id: "2", value: "Homologue" },
    { id: "3", value: "Salutation" },
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const cli = useSelector((state) => state.client);
  const { client } = cli;
  const cliListe = useSelector((state) => state.clientsListeState);
  const { clients } = cliListe;
  const msgCree = useSelector((state) => state.msgCree);
  const { message, erreur } = msgCree;

  useEffect(() => {
    let filteredClients = [];
    if (!clients) {
      dispatch(listeClients());
    } else {
      if (client.nivcli_cloud === "F") {
        filteredClients = clients.filter(
          (c) => c?.token_notif && c.nivcli_cloud === "A"
        );
      } else {
        filteredClients = clients.filter((c) => c?.token_notif);
      }

      const options = filteredClients.map((c) => ({
        value: c.token_notif,
        label: c.nom_cli,
      }));

      setClientOptions(options);
    }
  }, []);

  const handleClientChange = (value) => {
    console.log(value);
    //console.log(selectedClients);
    setSelectedClients({
      ...selectedClients,
      _id: value[1],
      value: value[0],
    });
  };

  const msgCreeHandler = async () => {
    if (!text_msg) {
      alert("Please enter a message");
      return;
    }

    if (selectedClients.length === 0) {
      alert("Please select at least one recipient");
      return;
    }

    setEdit(true);

    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
      };

      const payload = {
        token: selectedClients,
        obj_msg: client.nivcli_cloud === "A" ? obj_msg : "Reclamation",
        text_msg,
        cod_user: client.cod_cli,
        nom_user: client.nom_cli,
        nivcli_cloud: client.nivcli_cloud,
      };

      const { data } = await axios.post(
        `${process.env.REACT_APP_SERV_1}/api/messages`,
        payload,
        config
      );

      setEdit(false);

      if (data) {
        message.success("Message sent successfully!");
        navigate(-1); // Go back to previous page
      }
    } catch (error) {
      setEdit(false);
      alert(error.message || "Failed to send message");
      console.error(error);
    }
  };

  return (
    <div className="message-create-container">
      <div className="message-create-header">
        <img src={messageimg} alt="Message" className="message-create-image" />
        <h2 className="message-create-title">Nouveau Message</h2>
      </div>

      <div className="message-create-form">
        {client.nivcli_cloud === "A" && (
          <div className="message-create-field">
            <label className="message-create-label">Objet</label>
            <Select
              placeholder="Choisir Objet"
              className="message-create-select"
              onChange={setObjMsg}
              value={obj_msg || undefined}
            >
              {categoryOptions.map((cat) => (
                <Option key={cat.id} value={cat.value}>
                  {cat.value}
                </Option>
              ))}
            </Select>
          </div>
        )}

        <div className="message-create-field">
          <label className="message-create-label">Message</label>
          <textarea
            className="message-create-textarea"
            value={text_msg}
            onChange={(e) => setTextMsg(e.target.value)}
            rows={8}
          />
        </div>

        <div className="message-create-field">
          <label className="message-create-label">Récépteurs</label>
          <Select
            mode="multiple"
            placeholder="Choisir récépteurs"
            className="message-create-select"
            onChange={handleClientChange}
            value={selectedClients}
            options={clientOptions}
          />
        </div>

        <button
          className="message-create-button"
          onClick={msgCreeHandler}
          disabled={edit}
        >
          {edit ? "Sending..." : "Envoyer"}
        </button>
      </div>
      {edit && (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      )}
    </div>
  );
};

export default MessageCree;
